import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-create-file-modal',
  templateUrl: './create-file-modal.component.html',
  styleUrls: ['./create-file-modal.component.scss']
})
export class CreateFileModalComponent {
  @Output() closeModal = new EventEmitter<void>();
  @Output() createFile = new EventEmitter<string>();

  fileName: string = '';

  onCancel(): void {
    this.closeModal.emit();
  }

  onCreate(): void {
    const trimmedName = this.fileName.trim();
    if (trimmedName) {
      this.createFile.emit(trimmedName);
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onCreate();
    } else if (event.key === 'Escape') {
      this.onCancel();
    }
  }
}
